import React from 'react';
import { injectIntl } from 'gatsby-plugin-intl';
import { useStaticQuery, graphql } from 'gatsby';

import H3 from './styledComponents/H3';

import { Container,Cell,Grid,AnchorBlock,ChapterHeader,IconItem,ParentAnchor } from './blockComponents'

function Icons({ 
    intl,
    activeAnchor,
    setActiveAnchor,
    pageHeight,
    refs
    }) {
    const data = useStaticQuery(graphql`
        query Icons {
            allIconsListJson {
                edges {
                    node {
                        General {
                            icon_path
                            description_en
                            description_ru
                            description_uk
                        }
                        App {
                            icon_path
                            description_en
                            description_ru
                            description_uk
                        }
                        Cloud {
                            icon_path
                            description_en
                            description_ru
                            description_uk
                        }
                        Jeweller {
                            icon_path
                            description_en
                            description_ru
                            description_uk
                        }
                        Hub {
                            icon_path
                            description_en
                            description_ru
                            description_uk
                        }
                        MotionProtect {
                            icon_path
                            description_en
                            description_ru
                            description_uk
                        }
                        Button {
                            icon_path
                            description_en
                            description_ru
                            description_uk
                        }
                        DoorProtect {
                            icon_path
                            description_en
                            description_ru
                            description_uk
                        }
                        GlassProtect {
                            icon_path
                            description_en
                            description_ru
                            description_uk
                        }
                        FireProtect {
                            icon_path
                            description_en
                            description_ru
                            description_uk
                        }
                        LeaksProtect {
                            icon_path
                            description_en
                            description_ru
                            description_uk
                        }
                        SpaceControl {
                            icon_path
                            description_en
                            description_ru
                            description_uk
                        }
                        KeyPad {
                            icon_path
                            description_en
                            description_ru
                            description_uk
                        }
                        Siren {
                            icon_path
                            description_en
                            description_ru
                            description_uk
                        }
                        Socket {
                            icon_path
                            description_en
                            description_ru
                            description_uk
                        }
                        Briges {
                            icon_path
                            description_en
                            description_ru
                            description_uk
                        }
                    }
                }
            }
        }
    `)
    return (
        <ParentAnchor
            key='iconsSection'
            blockId="icons-section"
            blockName='iconsSection'
            refs={refs}>
            <ChapterHeader title={intl.formatMessage({ id: 'MainMenu_9' })}  downloadLink="https://drive.google.com/drive/folders/1JKQoHzcXg_hyYfGWUpx6KmaI5g0jzLlv?usp=sharing"></ChapterHeader>
            <Container>
                <Grid>
                    <Cell col={12} colXl={10} colXxl={8} leftXl={2} leftXxl={3}>
                        <AnchorBlock
                            key='generalIcons'
                            blockName='generalIcons'
                            blockId='general-icons'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'icons_1' })}</H3>
                            <Grid>
                                {
                                    data.allIconsListJson.edges[0].node.General.map((item) => {
                                        return (
                                            <Cell 
                                                key={item.icon_path} 
                                                col={12} 
                                                colSm={6} 
                                                colMd={4} 
                                                colLg={4} 
                                                colXxl={3}><IconItem iconPath={item.icon_path} desc={intl.locale === 'ru' ? item.description_ru : intl.locale === 'uk' ? item.description_uk : item.description_en} /></Cell>
                                        );
                                    })
                                }
                            </Grid>
                        </AnchorBlock>
                        <AnchorBlock
                            key='appIcons'
                            blockName='appIcons'
                            blockId='app-icons'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'icons_2' })}</H3>
                            <Grid>
                                {
                                    data.allIconsListJson.edges[0].node.App.map((item) => {
                                        return (
                                            <Cell 
                                                key={item.icon_path} 
                                                col={12} 
                                                colSm={6} 
                                                colMd={4} 
                                                colLg={4} 
                                                colXxl={3}><IconItem iconPath={item.icon_path} desc={intl.locale === 'ru' ? item.description_ru : intl.locale === 'uk' ? item.description_uk : item.description_en} /></Cell>
                                        );
                                    })
                                }
                            </Grid>
                        </AnchorBlock>
                        <AnchorBlock
                            key='cloudIcons'
                            blockName='cloudIcons'
                            blockId='cloud-icons'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'icons_3' })}</H3>
                            <Grid>
                                {
                                    data.allIconsListJson.edges[0].node.Cloud.map((item) => {
                                        return (
                                            <Cell 
                                                key={item.icon_path} 
                                                col={12} 
                                                colSm={6} 
                                                colMd={4} 
                                                colLg={4} 
                                                colXxl={3}><IconItem iconPath={item.icon_path} desc={intl.locale === 'ru' ? item.description_ru : intl.locale === 'uk' ? item.description_uk : item.description_en} /></Cell>
                                        );
                                    })
                                }
                            </Grid>
                        </AnchorBlock>
                        <AnchorBlock
                            key='jewellerIcons'
                            blockName='jewellerIcons'
                            blockId='jeweller-icons'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'icons_4' })}</H3>
                            <Grid>
                                {
                                    data.allIconsListJson.edges[0].node.Jeweller.map((item) => {
                                        return (
                                            <Cell 
                                                key={item.icon_path} 
                                                col={12} 
                                                colSm={6} 
                                                colMd={4} 
                                                colLg={4} 
                                                colXxl={3}><IconItem iconPath={item.icon_path} desc={intl.locale === 'ru' ? item.description_ru : intl.locale === 'uk' ? item.description_uk : item.description_en} /></Cell>
                                        );
                                    })
                                }
                            </Grid>
                        </AnchorBlock>
                        <AnchorBlock
                            key='centralIcons'
                            blockName='centralIcons'
                            blockId='central-icons'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'icons_5' })}</H3>
                            <Grid>
                                {
                                    data.allIconsListJson.edges[0].node.Hub.map((item) => {
                                        return (
                                            <Cell 
                                                key={item.icon_path} 
                                                col={12} 
                                                colSm={6} 
                                                colMd={4} 
                                                colLg={4} 
                                                colXxl={3}><IconItem iconPath={item.icon_path} desc={intl.locale === 'ru' ? item.description_ru : intl.locale === 'uk' ? item.description_uk : item.description_en} /></Cell>
                                        );
                                    })
                                }
                            </Grid>
                        </AnchorBlock>
                        <AnchorBlock
                            key='motionIcons'
                            blockName='motionIcons'
                            blockId='motionprotect-icons'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'icons_6' })}</H3>
                            <Grid>
                                {
                                    data.allIconsListJson.edges[0].node.MotionProtect.map((item) => {
                                        return (
                                            <Cell 
                                                key={item.icon_path} 
                                                col={12} 
                                                colSm={6} 
                                                colMd={4} 
                                                colLg={4} 
                                                colXxl={3}><IconItem iconPath={item.icon_path} desc={intl.locale === 'ru' ? item.description_ru : intl.locale === 'uk' ? item.description_uk : item.description_en} /></Cell>
                                        );
                                    })
                                }
                            </Grid>
                        </AnchorBlock>
                        <AnchorBlock
                            key='buttonIcons'
                            blockName='buttonIcons'
                            blockId='button-icons'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'icons_7' })}</H3>
                            <Grid>
                                {
                                    data.allIconsListJson.edges[0].node.Button.map((item) => {
                                        return (
                                            <Cell 
                                                key={item.icon_path} 
                                                col={12} 
                                                colSm={6} 
                                                colMd={4} 
                                                colLg={4} 
                                                colXxl={3}><IconItem iconPath={item.icon_path} desc={intl.locale === 'ru' ? item.description_ru : intl.locale === 'uk' ? item.description_uk : item.description_en} /></Cell>
                                        );
                                    })
                                }
                            </Grid>
                        </AnchorBlock>
                        <AnchorBlock
                            key='doorIcons'
                            blockName='doorIcons'
                            blockId='doorprotect-icons'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'icons_8' })}</H3>
                            <Grid>
                                {
                                    data.allIconsListJson.edges[0].node.DoorProtect.map((item) => {
                                        return (
                                            <Cell 
                                                key={item.icon_path} 
                                                col={12} 
                                                colSm={6} 
                                                colMd={4} 
                                                colLg={4} 
                                                colXxl={3}><IconItem iconPath={item.icon_path} desc={intl.locale === 'ru' ? item.description_ru : intl.locale === 'uk' ? item.description_uk : item.description_en} /></Cell>
                                        );
                                    })
                                }
                            </Grid>
                        </AnchorBlock>
                        <AnchorBlock
                            key='glassIcons'
                            blockName='glassIcons'
                            blockId='glassprotect-icons'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'icons_9' })}</H3>
                            <Grid>
                                {
                                    data.allIconsListJson.edges[0].node.GlassProtect.map((item) => {
                                        return (
                                            <Cell 
                                                key={item.icon_path} 
                                                col={12} 
                                                colSm={6} 
                                                colMd={4} 
                                                colLg={4} 
                                                colXxl={3}><IconItem iconPath={item.icon_path} desc={intl.locale === 'ru' ? item.description_ru : intl.locale === 'uk' ? item.description_uk : item.description_en} /></Cell>
                                        );
                                    })
                                }
                            </Grid>
                        </AnchorBlock>
                        <AnchorBlock
                            key='fireIcons'
                            blockName='fireIcons'
                            blockId='fireprotect-icons'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'icons_10' })}</H3>
                            <Grid>
                                {
                                    data.allIconsListJson.edges[0].node.FireProtect.map((item) => {
                                        return (
                                            <Cell 
                                                key={item.icon_path} 
                                                col={12} 
                                                colSm={6} 
                                                colMd={4} 
                                                colLg={4} 
                                                colXxl={3}><IconItem iconPath={item.icon_path} desc={intl.locale === 'ru' ? item.description_ru : intl.locale === 'uk' ? item.description_uk : item.description_en} /></Cell>
                                        );
                                    })
                                }
                            </Grid>
                        </AnchorBlock>
                        <AnchorBlock
                            key='leaksIcons'
                            blockName='leaksIcons'
                            blockId='leaks-icons'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'icons_11' })}</H3>
                            <Grid>
                                {
                                    data.allIconsListJson.edges[0].node.LeaksProtect.map((item) => {
                                        return (
                                            <Cell 
                                                key={item.icon_path} 
                                                col={12} 
                                                colSm={6} 
                                                colMd={4} 
                                                colLg={4} 
                                                colXxl={3}><IconItem iconPath={item.icon_path} desc={intl.locale === 'ru' ? item.description_ru : intl.locale === 'uk' ? item.description_uk : item.description_en} /></Cell>
                                        );
                                    })
                                }
                            </Grid>
                        </AnchorBlock>
                        <AnchorBlock
                            key='spaceIcons'
                            blockName='spaceIcons'
                            blockId='spacecontrol-icons'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'icons_12' })}</H3>
                            <Grid>
                                {
                                    data.allIconsListJson.edges[0].node.SpaceControl.map((item) => {
                                        return (
                                            <Cell 
                                                key={item.icon_path} 
                                                col={12} 
                                                colSm={6} 
                                                colMd={4} 
                                                colLg={4} 
                                                colXxl={3}><IconItem iconPath={item.icon_path} desc={intl.locale === 'ru' ? item.description_ru : intl.locale === 'uk' ? item.description_uk : item.description_en} /></Cell>
                                        );
                                    })
                                }
                            </Grid>
                        </AnchorBlock>
                        <AnchorBlock
                            key='keypadIcons'
                            blockName='keypadIcons'
                            blockId='keypad-icons'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'icons_13' })}</H3>
                            <Grid>
                                {
                                    data.allIconsListJson.edges[0].node.KeyPad.map((item) => {
                                        return (
                                            <Cell 
                                                key={item.icon_path} 
                                                col={12} 
                                                colSm={6} 
                                                colMd={4} 
                                                colLg={4} 
                                                colXxl={3}><IconItem iconPath={item.icon_path} desc={intl.locale === 'ru' ? item.description_ru : intl.locale === 'uk' ? item.description_uk : item.description_en} /></Cell>
                                        );
                                    })
                                }
                            </Grid>
                        </AnchorBlock>
                        <AnchorBlock
                            key='sirenIcons'
                            blockName='sirenIcons'
                            blockId='siren-icons'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'icons_14' })}</H3>
                            <Grid>
                                {
                                    data.allIconsListJson.edges[0].node.Siren.map((item) => {
                                        return (
                                            <Cell 
                                                key={item.icon_path} 
                                                col={12} 
                                                colSm={6} 
                                                colMd={4} 
                                                colLg={4} 
                                                colXxl={3}><IconItem iconPath={item.icon_path} desc={intl.locale === 'ru' ? item.description_ru : intl.locale === 'uk' ? item.description_uk : item.description_en} /></Cell>
                                        );
                                    })
                                }
                            </Grid>
                        </AnchorBlock>
                        <AnchorBlock
                            key='automationIcons'
                            blockName='automationIcons'
                            blockId='automation-icons'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'icons_15' })}</H3>
                            <Grid>
                                {
                                    data.allIconsListJson.edges[0].node.Socket.map((item) => {
                                        return (
                                            <Cell 
                                                key={item.icon_path} 
                                                col={12} 
                                                colSm={6} 
                                                colMd={4} 
                                                colLg={4} 
                                                colXxl={3}><IconItem iconPath={item.icon_path} desc={intl.locale === 'ru' ? item.description_ru : intl.locale === 'uk' ? item.description_uk : item.description_en} /></Cell>
                                        );
                                    })
                                }
                            </Grid>
                        </AnchorBlock>
                        <AnchorBlock
                            key='intagrationIcons'
                            blockName='intagrationIcons'
                            blockId='intagration-icons'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'icons_16' })}</H3>
                            <Grid>
                                {
                                    data.allIconsListJson.edges[0].node.Briges.map((item) => {
                                        return (
                                            <Cell 
                                                key={item.icon_path} 
                                                col={12} 
                                                colSm={6} 
                                                colMd={4} 
                                                colLg={4} 
                                                colXxl={3}><IconItem iconPath={item.icon_path} desc={intl.locale === 'ru' ? item.description_ru : intl.locale === 'uk' ? item.description_uk : item.description_en} /></Cell>
                                        );
                                    })
                                }
                            </Grid>
                        </AnchorBlock>
                    </Cell>
                </Grid>
            </Container>
        </ParentAnchor>
    )
}

export default injectIntl(Icons)